/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { DetailRequest, DetailRequestDefaultProp } from '../../../../utils/globalPropTypes';
import ProviderRequestDetailsContainer from '../../../../components/ProvidersForm/ProviderRequestDetailsContainer';
import { ubicationTypeEnum } from '../../../../utils/dataStatus';

const ProviderContainer = ({ details, setNewProviderData }) => {
  const providerContainerRef = useRef();

  useEffect(() => {
    setNewProviderData(providerContainerRef?.current?.values?.providers);
  }, [providerContainerRef?.current?.values]);

  const initialValues = {
    isOyM:
      details.tipoUbicacion?.id !== ubicationTypeEnum.pozo &&
      details.tipoUbicacion?.id !== ubicationTypeEnum.locacion,
    providers: [
      {
        contract: null,
        notificate: null,
        provider: null,
        businessUnit: {
          id: details.unidadNegocio.id,
          value: details.unidadNegocio.id,
          nombre: details.unidadNegocio.nombre,
          label: details.unidadNegocio.nombre
        }
      }
    ]
  };

  const validationSchema = Yup.object().shape({
    providers: Yup.array().of(
      Yup.object().shape({
        provider: Yup.object().nullable().required('Ingrese proveedor'),
        contract: Yup.object().nullable().required('Seleccione contrato'),
        businessUnit: Yup.object().nullable().required('Seleccione unidad de Negocio'),
        notificate: Yup.object().nullable().required('Seleccione notificador')
      })
    )
  });

  return (
    <Formik
      initialValues={initialValues}
      innerRef={providerContainerRef}
      validationSchema={validationSchema}
    >
      {({ values }) => (
        <Form>
          <ProviderRequestDetailsContainer
            details={details}
            providerField="providers"
            providerValue={values}
            setNewProviderData={setNewProviderData}
          />
        </Form>
      )}
    </Formik>
  );
};

ProviderContainer.propTypes = {
  details: DetailRequest,
  setNewProviderData: PropTypes.func.isRequired
};
ProviderContainer.defaultProps = {
  details: DetailRequestDefaultProp
};

export default ProviderContainer;
